:host {
  display: block;

  font-family: 'IBM Plex Sans', sans-serif;
  --primary-color: #000;
  --bg-color: #fff;
  --text-color: #333;
  --border-color: #000;
  --hover-bg: #e0e0e0;
}

.culturehack-search-container * {
  box-sizing: border-box;
  font-family: 'IBM Plex Sans', sans-serif;
}

.search-results {
  font-family: 'IBM Plex Sans', sans-serif;
}

.search-results code {
  font-family: 'IBM Plex Mono', monospace;
}

/* Search icon container */
.search-icon-container {
  position: fixed;
  top: 20px;
  right: 20px;
  height: 40px;
  display: flex;
  align-items: center;
  /* background-color: #f5f5f5; */
  border-radius: 1px;
  border: 1px solid var(--border-color);
  cursor: pointer;
  z-index: 100;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, background-color 0.2s ease;
  padding: 0 12px 0 18px;
  min-width: 180px;
}

.search-text {
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-right: auto;
}

.search-icon-button {
  background: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
}

.search-icon-container:hover {
  background-color: var(--hover-bg);
  transform: scale(1.03);
}

/* Modal backdrop */
.search-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
  display: block;
}

/* Modal content */
.search-modal-content {
  width: 600px;
  max-width: 95%;
  max-height: 80vh;
  background-color: var(--bg-color);
  border-radius: 1px;
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  /* Explicit positioning */
  position: fixed !important;
  top: 80px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  margin: 0 !important;
  z-index: 1001 !important;
}

.search-modal-header {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  position: relative;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
}

.search-input-wrapper .search-icon {
  position: absolute;
  left: 12px;
  color: #777;
}

.search-modal-input {
  flex: 1;
  height: 40px;
  font-size: 16px;
  border: none;
  outline: none;
  padding: 0 40px 0 40px;
  background-color: transparent;
  width: 100%;
}

.search-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  transition: color 0.2s ease;
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  padding: 0;
}

.search-modal-close:hover {
  color: var(--primary-color);
}

.search-results-container {
  max-height: 70vh;
  overflow-y: auto;
  padding: 0 16px;
}

.search-status {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 16px;
}

.search-results-list {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.search-results-count {
  margin: 12px 0;
  font-size: 14px;
  color: #666;
}

.search-results-empty {
  text-align: center;
  padding: 20px;
  color: #666;
  font-size: 16px;
}

.result-group {
  margin-bottom: 16px;
}

/* Styles for placeholder content */
.search-modal-body {
  padding: 16px 0;
  overflow-y: auto;
  max-height: 70vh;
}

/* Webkit scrollbar styling (Chrome, Safari, Edge) */
.search-results-container::-webkit-scrollbar {
  width: 8px;
}

.search-results-container::-webkit-scrollbar-track {
  background: transparent;
}

.search-results-container::-webkit-scrollbar-thumb {
  background-color: var(--primary-color);
  border-radius: 0;
}

/* Loading indicator */
.search-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
  color: var(--text-color);
}

.search-loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Result stats */
.search-result-stats {
  margin-bottom: 16px;
  padding-left: 16px;
  font-size: 14px;
  color: #666;
}

/* No results message */
.no-results {
  text-align: center;
  padding: 24px 0;
  color: #666;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Legacy styles - keeping for backward compatibility */
.search-bar {
  box-sizing: border-box;
  width: 400px;
  height: 30px;
  color: #000;
  border: 1px solid #000;
  border-radius: 1px;
  font-size: 16px;
  outline: none;
  margin-bottom: 10px;
}

.search-bar:focus {
  outline: none;
  border: 1px solid #000;
}
